import { ValidationResult } from '../types'
import i18n from 'i18next'

const validatePhoneNumber = (
	phoneNumber: string | undefined,
): ValidationResult => {
	if (phoneNumber == null || phoneNumber.length < 5) {
		return {
			success: false,
			output: i18n.t('validation-fieldRequired'),
		}
	}
	return {
		success: true,
		output: phoneNumber,
	}
}

export default validatePhoneNumber
